import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';

import { DownloadCsvTemplateComponent } from '@main-client/src/app/download-csv-template/download-csv-template.component';

@NgModule({
  imports: [CommonModule, MatButtonModule],
  declarations: [DownloadCsvTemplateComponent],
  exports: [DownloadCsvTemplateComponent],
})
export class DownloadCsvTemplateModule {}
